import '.aw{position:relative;}.ssr-plugin'
import '.n{width:100%;}.ssr-plugin'
import '.ha{min-height:200px;}.ssr-plugin'
import '.a{display:flex;}.ssr-plugin'
import '.b{flex-direction:column;}.ssr-plugin'
import '.as{justify-content:center;}.ssr-plugin'
import '.ag{align-items:flex-start;}.ssr-plugin'
import '.ea{padding:2rem;}.ssr-plugin'
import '.dx{background:var(--palette-white);}.ssr-plugin'
import '.b8{overflow:hidden;}.ssr-plugin'
import '.bn{position:absolute;}.ssr-plugin'
import '.k7{top:50%;}.ssr-plugin'
import '.k8{right:1rem;}.ssr-plugin'
import '.k9{transform:translateY(-50%);}.ssr-plugin'
import '.ka{width:120px;}.ssr-plugin'
import '.kb{height:120px;}.ssr-plugin'
import '.kc{z-index:0;}.ssr-plugin'
import '.t{align-items:center;}.ssr-plugin'
import '.h5{z-index:1;}.ssr-plugin'
import '.u{gap:0.5rem;}.ssr-plugin'
import '.kd{max-width:calc(100% - 140px);}.ssr-plugin'
import '.ke{font-size:4rem;}.ssr-plugin'
import '.cg{font-weight:700;}.ssr-plugin'
import '.kf{line-height:100%;}.ssr-plugin'
import '.gx{margin:0px;}.ssr-plugin'
import '.a3{color:var(--brand-secondary);}.ssr-plugin'
import '.a4{font-family:FunnelDisplay;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { Image } from '@app/components/core/image/Image'

export interface StatisticProps {
  number: string
  subtitle: string
  illustration?: string
  style?: Style
}

export const Statistic = ({
  number,
  subtitle,
  illustration,
  style,
}: StatisticProps) => {
  return (
    <styled.div className="aw n ha a b as ag ea dx b8"
      data-testid="statistic"
      style={{
        ...style,
      }}
    >
      {/* Background Illustration - Right Aligned */}
      {illustration && (
        <div className="bn k7 k8 k9 ka kb kc a t as"
        >
          <Image
            src={illustration}
            alt={`${subtitle} illustration`}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'contain',
            }}
          />
        </div>
      )}

      {/* Content - Left Aligned with higher z-index */}
      <div className="aw h5 a b ag u kd"
      >
        <div className="ke cg kf gx a3 a4"
        >
          {number}
        </div>

        {/* Subtitle */}
        <Text.Medium
          style={{
            color: 'var(--brand-secondary)',
            opacity: 0.8,
            margin: 0,
            lineHeight: '140%',
            fontWeight: '400',
          }}
        >
          {subtitle}
        </Text.Medium>
      </div>
    </styled.div>
  )
}
